<template>
  <div>
    <table width="100%" style="border-collapse:collapse; font-family:sans-serif; font-size:13px">
      <thead>
        <tr>
          <th>
            <my-header h1="Fee Payment Receipt" :h2="data.DepositDate" h3=""></my-header>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <table width="100%">
              <tr>
                <th width="17" style="text-align:left">Challan #:</th>
                <!--<th width="17" style="text-align:left">Session:</th>-->
                <th width="17" style="text-align:left">Name:</th>
                <th width="17" style="text-align:left">Department:</th>
              </tr>
              <tr>
                <td width="16" v-text="data.ChallanNo"></td>
                <!--<td width="16" v-text="data.Session"></td>-->
                <td width="17" v-text="data.Name"></td>
                <td width="16" v-text="data.Department"></td>
              </tr>
              <tr>
                <th width="17" style="text-align:left">Program:</th>
                <!--<th width="17" style="text-align:left">Roll No:</th>-->
              </tr>
              <tr>
                <td width="16" v-text="data.ProgramName"></td>
                <!--<td width="17" v-text="data.RollNo"></td>-->
              </tr>
            </table>
            <table border="1" width="100%" style="border-collapse:collapse; margin-top:10px; border-color:lightgray; stroke-opacity:50%" class="custom">
              <tr>
                <th style="text-align: left; padding: 10px; width: 80%">Fee Head</th>
                <th style="text-align: left; padding: 10px; width: 18%">Amount Paid</th>
              </tr>
              <tr v-for="(item, ind) in heads">
                <td style="padding: 10px; width: 80%">{{item.Name}}</td>
                <td style="text-align: right; padding: 10px; width: 18%">{{item.Total.toLocaleString()}}</td>
              </tr>
              <tr>
                <th width="80" style="text-align: left; padding: 10px; width: 80%">Total</th>
                <td style="text-align: right; padding: 10px; width: 18%">{{total.toLocaleString()}}</td>
              </tr>
            </table>
            <table width="100%">
              <tr>
                <td style="text-align: center; ">
                  <p style="padding: 10px !important">This is a system generated receipt it does'nt required any sign or stamp.</p>
                  <hr />
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>


<script>
  const axios = require('axios').default;
  export default ({
    data() {
      return {
        data: {},
        heads: [],
        total: '',
      }
    },
    mounted: function () {
      this.pagePrint();
    },
    methods: {
      pagePrint() {
        var vm = this;
        axios.post('/api/FeeApi/PrintDepositSlip')
          .then(function (res) {
            vm.data = res.data.lst;
            vm.total = res.data.total;
            vm.heads = res.data.lst.child;
          })
      }
    }
  })
</script>

<style>
  p {
    margin: 0 0 0 0;
  }

  .custom tr:nth-child(odd) {
    background-color: #f2f2f2;
  }
</style>



// WEBPACK FOOTER //
// src/components/Fee/feedepositprint.vue